import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowForm } from 'app/models/workflow-form';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-add-edit-auto-start-form',
  templateUrl: './add-edit-auto-start-form.component.html',
  styleUrls: ['./add-edit-auto-start-form.component.scss']
})
export class AddEditAutoStartFormComponent implements OnInit {

  @ViewChild('addEditAutoStartFormModal', { static: true }) addEditAutoStartFormModal: ModalDirective;

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() workflowForms: WorkflowForm[];
  @Input() isEdit: boolean;

  autoStartFormToAddFormGroup: FormGroup;

  sameTemplateForms: WorkflowForm[] = [];

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedFieldsTableLimit: number = 100;

  constructor(private validationHandler: ValidationHandler) { }

  ngOnInit(): void {
  }
  
  show(frm: FormGroup) {
    this.autoStartFormToAddFormGroup = frm;
    this.sameTemplateForms = (this.autoStartFormToAddFormGroup.value.is_additional_form)? []: this.workflowForms.filter((f) => f.form_template.path.toLowerCase() == this.autoStartFormToAddFormGroup.value?.linked_workflow_form_path.toLowerCase());
    this.addEditAutoStartFormModal.show();
  }

  
  onAddAutoStartFormModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoStartFormToAddFormGroup);
    if(!this.autoStartFormToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.autoStartFormToAddFormGroup);
    this.addEditAutoStartFormModal.hide();
  }

  innerWidth() {
    return window.innerWidth;
  }
}
